module.exports = __webpack_public_path__ + "img/science_app_7.3bdfb6a9.jpg";